import axios from '@/axios';

const RESOURCE_NAME = '/needs';

export default {
    createNeed(need) {
        return axios.post(`${RESOURCE_NAME}/create-need`, {need});
    },

    getIndexList() {
        return axios.get(`${RESOURCE_NAME}/get-index-list`)
    },

    getTodos() {
        return axios.get(`${RESOURCE_NAME}/get-todos`);
    },

    getInfo(id) {
        return axios.get(`${RESOURCE_NAME}/get-info?id=${id}`)
    },

    getStatus(id) {
        return axios.get(`${RESOURCE_NAME}/get-status?id=${id}`)
    },

    getActivities(id) {
        return axios.get(`${RESOURCE_NAME}/get-activities?id=${id}`)
    },

    getOnboardingStep() {
        return axios.get(`${RESOURCE_NAME}/get-onboarding-step`)
    },

    saveOnboardingStep(step) {
        return axios.post(`${RESOURCE_NAME}/save-onboarding-step`, {step})
    },

    sendUpgradeRequest(id, data) {
        return axios.post(`${RESOURCE_NAME}/send-upgrade-request?id=${id}`, data)
    },

    setEcosystemsVisibility(id, value) {
        return axios.post(`${RESOURCE_NAME}/set-ecosystems-visibility?id=${id}`, {value})
    },

    escalate(id, data) {
        return axios.post(`${RESOURCE_NAME}/escalate?id=${id}`, data)
    },

    getReport(id) {
        return axios.get(`${RESOURCE_NAME}/get-report?id=${id}`,{
            responseType: 'blob',
        })
    },
}
